/**
 * Creates array of options for select box.
 * If available_count < min_count return [min_count]
 * @param {number} min_count minimum value of the select
 * @param {number} available_count maximum value of the select
 */
export default function(min_count, available_count) {
  if (available_count < min_count) {
    return [0];
  }

  if (available_count) {
    return Array.from({ length: Math.floor(available_count / min_count) }).map((_, n) => (n + 1));
  }

  return [];
}
